import React from "react";
import "./index.css";

const ToggleSwitch = (props: any) => {
    const {onChange, value, label, isCheckedIn} = props;

    return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px", height: "18px"}}>
            <div style={{fontWeight: 600, fontSize: "11px", color: "#282B31"}} data-test-id={`togglebtn-${label}`}>{label}</div>
            <div
                style={{cursor: isCheckedIn ? "pointer" : "not-allowed"}}
                className={value ? "tableToggle" : "tableToggle-container"}
                onClick={() => isCheckedIn && (value ? onChange(false) : onChange(true))}
                data-test-id={value ? `tableToggle-${label}` : `tableToggle-container-${label}`}
            >
                <span className={`tableDialog-button ${value ? "" : "tablebtnDisabled"}`}></span>
            </div>
        </div>
    )
}


export default ToggleSwitch;